import { ApolloClient } from '@apollo/client'

import {
  CartRemoveItem,
  CartRemoveItemVariables,
  CartRemoveItemDocument
} from './types/CartRemoveItem'

type Args = {
  client: ApolloClient<object>
  cartUuid: string
  itemIndex: number
}

export default function removeItem({ client, cartUuid, itemIndex }: Args) {
  return client.mutate<CartRemoveItem, CartRemoveItemVariables>({
    mutation: CartRemoveItemDocument,
    variables: { cartUuid: cartUuid!, itemIndex },
    refetchQueries: ['CheckoutCartQuery']
  })
}
